<template>
  <div>
    <component :is="layout" />
  </div>
</template>

<script>
const defaultLayout = "simple";
export default {
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    }
  },
  methods: {
    disableRTL() {
      if (!this.$rtl.isRTL) {
        this.$rtl.disableRTL();
      }
    }
    /* toggleNavOpen() {
      let root = document.getElementsByTagName("html")[0];
      root.classList.toggle("nav-open");
    } */
  },
  mounted() {
    this.disableRTL();
    //this.$watch("$route", this.disableRTL, { immediate: true });
    //this.$watch("$sidebar.showSidebar", this.toggleNavOpen);
  }
};
</script>

<style>
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.08);
}
</style>
